import { Link } from 'components/Elements';
import { Head } from 'components/Head';
import PropTypes from 'prop-types';
import logo from 'assets/logo-black.png';

export const Layout = ({ children, title }) => {
  return (
    <>
      <Head title={title} />

      <div className="min-h-screen bg-[#f4f1ea] text-[#111] font-serif flex flex-col">
        {/* TOP STRIP */}
        <div className="border-b border-black text-[11px] tracking-wide px-6 py-2 flex justify-between">
          <span>Mukutu Media — Editorial System</span>
          <span>{new Date().toDateString()}</span>
        </div>

        {/* MAIN GRID */}
        <div className="flex flex-1">
          {/* LEFT — EDITORIAL IDENTITY */}
          <div className="hidden lg:flex lg:w-1/2 border-r border-black p-12 flex-col justify-between bg-[#f4f1ea]">
            <div>
              {/* LOGO + MASTHEAD */}
              <Link to="/" className="block mb-10">
                <div className="flex items-center gap-4 mb-4">
                  <img src={logo} alt="Mukutu Media" className="h-12 w-auto object-contain" />
                </div>

                <h1 className="text-5xl font-bold tracking-tight text-black">MUKUTU MEDIA</h1>

                <p className="text-[11px] uppercase tracking-[0.3em] text-gray-600 mt-2">
                  Editorial Desk
                </p>
              </Link>

              {/* STATEMENT */}
              <div className="max-w-md">
                <h2 className="text-2xl font-semibold leading-snug mb-4">
                  Truth. Structure. Accountability.
                </h2>

                <p className="text-sm text-gray-700 leading-relaxed">
                  Mukutu Media operates a disciplined editorial system designed for accurate
                  reporting, structured publishing, and responsible journalism. Access is restricted
                  to verified personnel only.
                </p>
              </div>
            </div>

            {/* FOOTER */}
            <div className="text-xs text-gray-500">
              Kampala, Uganda
              <br />© {new Date().getFullYear()} Mukutu Media
            </div>
          </div>

          {/* RIGHT — LOGIN */}
          <div className="w-full lg:w-1/2 flex items-center justify-center px-6 py-12 bg-[#f4f1ea]">
            <div className="w-full max-w-md border border-black bg-white p-8">
              {/* LOGO (Mobile Only) */}
              <div className="lg:hidden flex flex-col items-center mb-6">
                <Link to="/">
                  <img src={logo} alt="Mukutu Media" className="h-10 w-auto mb-3" />
                </Link>
                <h1 className="text-xl font-bold">MUKUTU MEDIA</h1>
              </div>

              {/* TITLE */}
              <div className="mb-6 text-center">
                <h2 className="text-2xl font-semibold">{title}</h2>

                <p className="text-[11px] uppercase tracking-widest text-gray-500 mt-2">
                  Authorized Access Only
                </p>
              </div>

              {/* FORM */}
              <div className="space-y-4">{children}</div>

              {/* DIVIDER */}
              <div className="border-t border-black my-6"></div>

              {/* SECURITY NOTE */}
              <p className="text-[11px] text-gray-500 text-center">
                All access is monitored and logged.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};
